import { type LoaderFunctionArgs, redirect } from "react-router";
import { experienceDesignAuthorization } from "src/configs/authorization/experience-design";
import { PAGES, PAGE_URLS } from "src/configs/pages-urls";
import { redirectsMapping } from "src/module--journey/config/router";
import {
	generateRedirectsMapping,
	getRedirectRoutes,
} from "src/module--journey/utils/router";
import { authorizationLoader } from "src/router/common-loaders";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		path: PAGES.experienceDesign.sub.journeyPromotion,
		lazy: () =>
			import("src/module--journey/pages/JourneyPromotion.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.experienceDesign.sub.journey,
		loader: () => redirect(PAGE_URLS.experienceDesign().clients),
	},
	{
		path: PAGES.experienceDesign.sub.clients,
		lazy: () =>
			import("src/module--journey/pages/ClientList.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.clients}/new`,
		lazy: () =>
			import("src/module--journey/pages/ClientCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.clients}/:id`,
		lazy: () =>
			import("src/module--journey/pages/ClientEdit.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.experienceDesign.sub.layouts,
		lazy: () =>
			import("src/module--journey/pages/LayoutList.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.experienceDesign.sub.journeys,
		lazy: () =>
			import("src/module--journey/pages/FlowsList.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.journeys}/:journeyId`,
		lazy: () =>
			import("src/module--journey/pages/JourneyEdit.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.journeys}/:journeyId/${PAGES.experienceDesign.sub.flowAnalysis}`,
		lazy: () =>
			import("src/module--journey/pages/FlowAnalysis.page").then(
				convertFrameworkRoute,
			),
		children: [
			{
				path: "message/:messageTypeId",
				lazy: () =>
					import(
						"src/module--journey/pages/FlowAnalysisMessageDetails.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: `${PAGES.experienceDesign.sub.journeys}/new`,
		lazy: () =>
			import("src/module--journey/pages/JourneyCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.journeys}/:journeyId/${PAGES.experienceDesign.sub.flowVisualize}`,
		lazy: () =>
			import("src/module--journey/pages/FlowCharts.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.journeys}/:journeyId/${PAGES.experienceDesign.sub.flowVisualize}/new`,
		lazy: () =>
			import("src/module--journey/pages/FlowChartNew.page").then(
				convertFrameworkRoute,
			),
		children: [
			{
				path: ":messageTypeId",
				lazy: () =>
					import(
						"src/module--journey/pages/FlowChartDetails.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: `${PAGES.experienceDesign.sub.journeys}/:journeyId/${PAGES.experienceDesign.sub.flowVisualize}/:flowChartId`,
		lazy: () =>
			import("src/module--journey/pages/FlowChart.page").then(
				convertFrameworkRoute,
			),
		children: [
			{
				path: ":messageTypeId",
				lazy: () =>
					import(
						"src/module--journey/pages/FlowChartDetails.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: `${PAGES.experienceDesign.sub.layouts}/new`,
		lazy: () =>
			import("src/module--journey/pages/LayoutCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.layouts}/:id`,
		lazy: () =>
			import("src/module--journey/pages/LayoutEdit.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.layouts}/:id/history`,
		lazy: () =>
			import("src/module--journey/pages/LayoutRevision.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.experienceDesign.sub.messages,
		lazy: () =>
			import("src/module--journey/pages/MessageTypeList.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.triggers}/:triggerId`,
		lazy: () =>
			import("src/module--journey/pages/TriggerDetails.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.triggers}/new`,
		lazy: () =>
			import("src/module--journey/pages/TriggerDetailsCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.messages}/new`,
		lazy: () =>
			import("src/module--journey/pages/MessageTypeCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.messages}/:id`,
		lazy: () =>
			import("src/module--journey/pages/MessageTypeDetails.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.messages}/:id/new`,
		lazy: () =>
			import("src/module--journey/pages/MessageCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.messages}/:id/:messageId`,
		lazy: () =>
			import("src/module--journey/pages/MessageEdit.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.messages}/:id/:messageId/history`,
		lazy: () =>
			import("src/module--journey/pages/MessageRevision.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.partials}`,
		lazy: () =>
			import("src/module--journey/pages/PartialList.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.partials}/new`,
		lazy: () =>
			import("src/module--journey/pages/PartialCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.partials}/:id/history`,
		lazy: () =>
			import("src/module--journey/pages/PartialRevision.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.partials}/:id`,
		lazy: () =>
			import("src/module--journey/pages/PartialEdit.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.experiments}`,
		lazy: () =>
			import("src/module--journey/pages/ExperimentsList.page").then(
				convertFrameworkRoute,
			),
		loader: async ({
			params: { accountId: accountIdParam },
		}: LoaderFunctionArgs) =>
			authorizationLoader(
				{ accountIdParam },
				experienceDesignAuthorization.experienceDesign
					.journeyExperiments,
			),
		children: [
			{
				path: "new",
				lazy: () =>
					import("src/module--journey/pages/ExperimentNew.page").then(
						convertFrameworkRoute,
					),
			},
			{
				path: ":id",
				lazy: () =>
					import(
						"src/module--journey/pages/ExperimentEdit.page"
					).then(convertFrameworkRoute),
			},
			{
				path: "result/:id",
				lazy: () =>
					import(
						"src/module--journey/pages/ExperimentResult.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: `${PAGES.experienceDesign.sub.experimentsMessages}/:experimentId/:id/:messageId/`,
		lazy: () =>
			import("src/module--journey/pages/MessageEdit.page").then(
				convertFrameworkRoute,
			),
		loader: async ({
			params: { accountId: accountIdParam },
		}: LoaderFunctionArgs) =>
			authorizationLoader(
				{ accountIdParam },
				experienceDesignAuthorization.experienceDesign
					.journeyExperiments,
			),
	},
	{
		path: PAGES.experienceDesign.sub.ondemandmessageaction,
		lazy: () =>
			import("src/module--journey/pages/OnDemandMessage.page").then(
				convertFrameworkRoute,
			),
	},
	...getRedirectRoutes(generateRedirectsMapping(redirectsMapping)),
];
